// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__3PNOx","errors":"Errors_errors__1l5ZR"};